var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clipPath_sAtbwWpG7ehvIzZaBIDTVeDsnPYC8qaN"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clipPath_sAtbwWpG7ehvIzZaBIDTVeDsnPYC8qaN)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 17.50000000000003,
    cy: 17.50000000000003,
    r: 17.5
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 17.5 17.5 C 19.71 17.5 21.5 15.71 21.5 13.5 C 21.5 11.29 19.71 9.5 17.5 9.5 C 15.29 9.5 13.5 11.29 13.5 13.5 C 13.5 15.71 15.29 17.5 17.5 17.5 Z  M 17.5 19.5 C 14.83 19.5 9.5 20.84 9.5 23.5 L 9.5 24.5 C 9.5 25.05 9.95 25.5 10.5 25.5 L 24.5 25.5 C 25.05 25.5 25.5 25.05 25.5 24.5 L 25.5 23.5 C 25.5 20.84 20.17 19.5 17.5 19.5 Z ",
    fill: "rgb(255,255,255)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/Contact.7a272025bdd53c95c88e316f6063d06d.svg";
export { ForwardRef as ReactComponent };